var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com"},[_c('div',{staticClass:"closeBox",on:{"click":_vm.close}},[_c('van-icon',{attrs:{"name":"cross","size":"22"}})],1),_c('div',{ref:"payCode",staticClass:"code",attrs:{"id":"payCode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }